import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {ModalType} from "../../../../core/models/custom/enums/modalType";
import {OfferDto} from "../../../../core/models/dtos/offer.dto";
import {OfferType} from "../../../../core/models/enums/offerType";
import FirebaseService from "../../../../core/services/firebase.service";
import {PaymentFailState} from "../../../../core/services/userService/paymentFail/types";
import ContentKeys from "../../../../core/utilities/contentKeys";
import {IStore} from "../../../../core/utilities/reducers";
import ContentKey from "../../../ContentKey/ContentKey";
import Offer from "./Offer/Offer";
import "./Offers.scss";

interface IProps {
  offers: OfferDto[];
  modal: ModalType;
  isTimeout?: boolean;
  callbackSelection: (offer: OfferDto) => void;
  paymentFailState: PaymentFailState;
}

const Offers = (props: IProps) => {
  
  const handleOffer = (offer: OfferDto): void => {
    if (props.paymentFailState.loading) {
      return;
    }
    switch (offer.type) {
      case OfferType.P2S:
        FirebaseService.logEvent(FirebaseService.user_count_p2s_click);
        break;
      case OfferType.J2F_S:
        FirebaseService.logEvent(FirebaseService.user_count_j2fs_click);
        break;
      case OfferType.P2C:
        FirebaseService.logEvent(FirebaseService.user_count_p2c_click);
        break;
      case OfferType.J2F:
        FirebaseService.logEvent(FirebaseService.user_count_j2f_click);
        break;
      case OfferType.GIVE_UP:
        FirebaseService.logEvent(FirebaseService.user_count_give_up_click);
        break;
    }
    props.callbackSelection(offer);
  }
  
  return (
    <div id="offers">
      {props.offers
        .sort((a, b) => a.position > b.position ? 1 : -1)
        .map(offer => {
          return (
            <Offer
              key={offer.type}
              type={props.offers.length === 1 ? OfferType.J2F : offer.type}
              body={
                <ContentKey
                  className="link-xsmall"
                  contentKey={ContentKeys.getOfferDescriptionKey(props.modal, offer.type, offer.level, props.isTimeout)}
                />
              }
              onClick={() => handleOffer(offer)}
            />
          );
        })}
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {},
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    paymentFailState: store.paymentFail,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
